<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">プロモーションマスタ一覧</th>
  </tr>
  <tr class="subwindow-body">
    <td colspan="2">
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <wj-flex-grid 
          class="wj-flexgrid" id="dtg_PromotionList" #dtg_PromotionList
          [itemsSource]="kymw4001Model.promotionList" [isReadOnly]="true" [allowSorting]="true"
          [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" forcedEnabledMode="true" [tabindex]="0" >
          <wj-flex-grid-column [minWidth]="5" [header]="'番号'" [width]="60" [binding]="'PromotionNo'" [align]="'left'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'left'">{{cell.item.PromotionNo}}</div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'プロモーション内容'" [width]="226.5" [binding]="'PromotionInfo'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'マーク１'" [width]="110" [binding]="'MarkCode1Name'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'マーク２'" [width]="110" [binding]="'MarkCode2Name'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'マーク３'" [width]="110" [binding]="'MarkCode3Name'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'マーク４'" [width]="110" [binding]="'MarkCode4Name'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'マーク５'" [width]="110" [binding]="'MarkCode5Name'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ダブル掲載'" [width]="124" [binding]="'MultiPublishFlagMark'" [align]="'center'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'center'">{{cell.item.MultiPublishFlagMark}}</div>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

    <tfoot cdkDragHandle>
      <tr>
        <td>
          <div class="footer-buttons">
            <button id="btn_Output" #btn_Output class="btn-secondary"
              (click)="this.eventOutput_CLICKHandler()" [disabled]="!kymw4001Model.btnOutputEnabled"
              forcedEnabledMode="true" [tabindex]="0">出力</button>
            <button id="btn_Regist" class="btn-primary"
              (click)="eventPromotion_CLICKHandler()" forcedEnabledMode="true" [autofocus]="true"
              [tabindex]="0">登録</button>
          </div>
          <div class="window-title-close">
            <button id="btn_Exit"
              (click)="onClickWindowClose()" forcedEnabledMode="true" [tabindex]="0"></button>
          </div>
        </td>
      </tr>
    </tfoot>
</table>
